'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.composeAsyncValidator = composeAsyncValidator;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Compose async validator function.
 *
 * @param validators {object}
 * @returns {function}
 */
function composeAsyncValidator(validators) {
  var _this = this;

  /**
   * Async validator function.
   *
   * @param values {object}
   * @param dispatch {function}
   * @param props {object}
   * @param blurredField {string}
   *
   * @returns Promise<object|undefined>
   */
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, dispatch, props, blurredField) {
      var asyncErrors, fieldValue, _validators$blurredFi, asyncFieldValidator, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof blurredField === 'undefined')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', Promise.resolve());

            case 2:
              asyncErrors = Object.assign({}, props.asyncErrors);
              fieldValue = values[blurredField];
              _validators$blurredFi = _slicedToArray(validators[blurredField], 2), asyncFieldValidator = _validators$blurredFi[0], message = _validators$blurredFi[1];
              _context.next = 7;
              return asyncFieldValidator(fieldValue).then(function () {
                delete asyncErrors[blurredField];
              }).catch(function () {
                return asyncErrors[blurredField] = message;
              });

            case 7:
              return _context.abrupt('return', Object.keys(asyncErrors).length ? Promise.reject(asyncErrors) : Promise.resolve());

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
}